require('./appHeader.i18n.json');
require('./appHeader.tpl.html');
require('./chatNotification/chatNotificationComponent.js');
require('./externalAccountModal/externalAccountModal.tpl.html');
require('./externalAccountModal/externalAccountModalController.js');
require('./externalAccountModal/repository/externalAccountRepository.js');
require('./myAuthorityModal/myAuthorityModal.i18n.json');
require('./myAuthorityModal/myAuthorityModal.tpl.html');
require('./myAuthorityModal/myAuthorityModalController.js');

/*@ngInject*/
const AppHeaderController = function ($rootScope, $scope, $uibModal, localization, coreMediator, coreConstant, modalUtil,
                                      authenticationMediator, appTypeConfigurationModel, submissionMediator, userStateModel,
                                      currentUserModel, authorizationConstants, uiPerformanceLoggerConstant, submissionUtil,
                                      headerUtil, currentSubmissionModel, userLoginType) {

    $scope.viewModel = {
        isCreatingSubmission: false,
        createSubmissionPermission: false
    };

    function init() {
        submissionUtil.restoreCreateSubmissionModal();

        $scope.viewModel.createSubmissionPermission = currentUserModel.hasAuthorization(authorizationConstants.SUBMISSION_CREATE);

        if (appTypeConfigurationModel.isUnderwriterWorkstation()) {
            $scope.viewModel.logoConfiguredFileName = 'HTML Underwriter Logo';
        } else if (appTypeConfigurationModel.isAgentConsole()) {
            $scope.viewModel.logoConfiguredFileName = 'HTML Agent Logo';
        }

            localization.getTranslationByKey('appHeader').then(function (translations) {
                let availableToChatMenuItem = {
                        identifier: 'availableToChat',
                        enabled: !userStateModel.isVisibleForChat(),
                        iconClass: 'glyphicon-online',
                        label: _.get(translations, 'userProfileDropdown.menuItems.availableToChat'),
                        action: setAvailableToChat
                    },
                    notAvailableToChatMenuItem = {
                        identifier: 'notAvailableToChat',
                        enabled: userStateModel.isVisibleForChat(),
                        iconClass: 'glyphicon-offline',
                        label: _.get(translations, 'userProfileDropdown.menuItems.notAvailableToChat'),
                        action: setNotAvailableToChat
                    },
                    profileMenuItem = {
                        identifier: 'profile',
                        enabled: true,
                        iconClass: 'glyphicon-user',
                        label: _.get(translations, 'userProfileDropdown.menuItems.profile'),
                        action: showUserProfile
                    },

                    myAuthorityMenuItem = {
                        identifier: 'myAuthority',
                        enabled: appTypeConfigurationModel.getUserType() === 'Underwriter',
                        iconClass: 'glyphicon-briefcase',
                        label: _.get(translations, 'userProfileDropdown.menuItems.myAuthority'),
                        action: showMyAuthority
                    },
                    externalAccountsMenuItem = {
                        identifier: 'externalAccounts',
                        enabled: true,
                        iconClass: 'glyphicon-user',
                        label: _.get(translations, 'userProfileDropdown.menuItems.externalAccounts'),
                        action: showExternalAccounts
                    },
                    logoutMenuItem = {
                        identifier: 'logout',
                        enabled: true,
                        iconClass: 'glyphicon-log-out',
                        label: _.get(translations, 'userProfileDropdown.menuItems.logout'),
                        action: logout
                    };


                $scope.viewModel.menuItems = [
                    availableToChatMenuItem,
                    notAvailableToChatMenuItem,
                    profileMenuItem,
                    myAuthorityMenuItem,
                    externalAccountsMenuItem,
                    logoutMenuItem
                ];

                coreMediator.loadUserProfile().then(function (userProfile) {
                    let currentUser = userProfile,
                        isAgentUser = (currentUser.userType === 'Agent'),
                        changePasswordMenuItem;
                    coreMediator.loadDefaultPreferences().then(function (preferences) {

                        if (((isAgentUser && preferences['system.disablePasswordAndProfileManagementAgent'].value === 'false') ||
                            (!isAgentUser && preferences['system.disablePasswordAndProfileManagementUnderwriter'].value === 'false')) &&
                            currentUserModel.getCurrentUser().loginType !== userLoginType.SINGLE_SIGN_ON) {
                            changePasswordMenuItem = {
                                identifier: 'changePassword',
                                enabled: true,
                                iconClass: 'glyphicon-lock',
                                label: _.get(translations, 'userProfileDropdown.menuItems.changePassword'),
                                action: showChangePassword
                            };
                            $scope.viewModel.menuItems.splice(3, 0, changePasswordMenuItem);
                            $scope.viewModel.menuItems.join();
                        }
                    }.bind(this));
                });

                $scope.viewModel.newSubmissionLabel = _.get(translations, 'newSubmissionLabel');
            });
        }

    function setAvailableToChat() {
        let visibleForChat = true;

        coreMediator.setChatVisibility(visibleForChat).then(function () {
            userStateModel.setVisibleForChat(visibleForChat);
        });
    }

    function setNotAvailableToChat() {
        let visibleForChat = false;

        coreMediator.setChatVisibility(visibleForChat).then(function () {
            userStateModel.setVisibleForChat(visibleForChat);
        });
    }

    function showUserProfile() {
        modalUtil.showUserProfile();
    }

    function showChangePassword() {
        authenticationMediator.showChangePasswordPopup();
    }

    function showMyAuthority() {
        coreMediator.getDynamicDataSetItems({name: 'Underwriter Letter of Authority Forms'}).then(function (dataSetItems) {
            if (!_.isEmpty(dataSetItems)) {
                $uibModal.open({
                    templateUrl: '/common/header/myAuthorityModal/myAuthorityModal.tpl.html',
                    controller: 'myAuthorityModalController',
                    windowClass: 'myAuthorityModal',
                    resolve: {
                        letterOfAuthorityForms: function () {
                            return dataSetItems;
                        }
                    },
                    keyboard: false,
                    backdrop: 'static'
                });
            } else {
                localization.getTranslationByKey('myAuthorityModal').then(function (translations) {
                    modalUtil.showGenericConfirm({
                        title: _.get(translations, 'noAuthoritiesTitle'),
                        summary: _.get(translations, 'noAuthoritiesMessage'),
                        cancelButtonLabel: _.get(translations, 'noAuthoritiesCancelButtonLabel')
                    });
                });
            }
        });
    }

    function showExternalAccounts() {
        $uibModal.open({
            templateUrl: '/common/header/externalAccountModal/externalAccountModal.tpl.html',
            controller: 'externalAccountModalController',
            backdrop: 'static',
            windowClass: 'externalAccountModal'
        });
    }

        function logout() {
            submissionMediator.resetOpenSubmissionList();
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.LOGOUT, coreConstant.uiPeformanceLogger.SUCCESS);
            coreMediator.logout().then(function(){
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.LOGOUT, coreConstant.uiPeformanceLogger.SUCCESS, '', true);
            }, function () {
                // On Error
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.LOGOUT, coreConstant.uiPeformanceLogger.FAIL,'' ,true);
            });
        }

    function updateMenuItemsWithVisibleForChat() {
        _.each($scope.viewModel.menuItems, function (menuItem) {
            if (menuItem.identifier === 'availableToChat') {
                menuItem.enabled = !userStateModel.isVisibleForChat();
            } else if (menuItem.identifier === 'notAvailableToChat') {
                menuItem.enabled = userStateModel.isVisibleForChat();
            }
        });
    }

    $scope.$on(coreConstant.event.ACORD_UPLOAD_NOTIFICATION, function (event, options, actionId) {
        let isAcordUploadCompleteReviewEffectiveDate = options.notificationName === 'acordUploadCompleteReviewEffectiveDate',
            isAcordUploadComplete = options.notificationName === 'acordUploadComplete',
            currentSubmission = currentSubmissionModel.getCurrentSubmission();

        if (isAcordUploadCompleteReviewEffectiveDate || isAcordUploadComplete) {
            if (!_.isNil(currentSubmission) && currentSubmission.id === parseInt(actionId)) {
                // if user is currently on same submission then we will display notification with 'OK' button.
                options.cancelButtonLabel = _.get(translations, 'alert.okButtonLabel');
                delete options.confirmActionButtonLabel;
            }
        }
        options.isAcordUploadCompleteReviewEffectiveDate = isAcordUploadCompleteReviewEffectiveDate;
        options.isAcordUploadComplete = isAcordUploadComplete;
        $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, options, actionId);
    });

    $scope.isActiveNavElement = function (type) {
        return headerUtil.isActiveNavElement(type);
    };

    $scope.isCreateSubmissionDisabled = function () {
        return $scope.viewModel.isCreatingSubmission || !$scope.viewModel.createSubmissionPermission;
    };

    $scope.onCreateSubmission = function () {

        function handleSuccess(newSubmissionPayload) {
            $scope.viewModel.isCreatingSubmission = false;
        }

        function handleError() {
            let logAction = uiPerformanceLoggerConstant.NEW_SUBMISSION,
                status = coreConstant.uiPeformanceLogger.FAIL;

            $scope.viewModel.isCreatingSubmission = false;

            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
        }

        if (!$scope.viewModel.isCreatingSubmission) {
            let logAction = uiPerformanceLoggerConstant.NEW_SUBMISSION,
                message = 'newSubmission';

            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
            $scope.viewModel.isCreatingSubmission = true;
            submissionUtil.createNewSubmission().then(handleSuccess, handleError);
        }
    };

    $scope.$on(coreConstant.event.CHAT_VISIBILITY_CHANGED, function () {
        updateMenuItemsWithVisibleForChat();
    });

    init();
};

angular.module('ums')
    .controller('appHeaderController', AppHeaderController);
